import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import ProgressMessage from 'components/Utils/ProgressMessage/index';
import DefaultButton from 'components/Utils/NewDefaultButton';
import './style.scss';
import Icon from 'components/Utils/NewIcon/index';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import { useQueryParams } from 'components/Navigation/NavStack';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { getTenantIdentity } from 'hooks/useTenantIdentity';

const ConfirmEmail = () => {
  const { name } = getTenantIdentity();
  const dispatch = useAppDispatch();
  const nav = useNavStack(Stacks.Master);

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  const { code, email } = useQueryParams();

  const errorState = !code || !email;

  useEffect(() => {
    if (!errorState) {
      dispatch(api.Authentication.verifyEmail({ emailVerification: { email, code } }), {
        meta: true,
      }).then(({ isSuccess }) => {
        setSuccess(isSuccess);
        setLoading(false);
      });
    }
  }, [dispatch, code, email, errorState]);

  function goToHome() {
    nav.popToRoot();
  }

  return (
    <div className="page confirm-email-screen">
      <div className="page-content padded-box">
        {errorState && (
          <>
            <Icon
              src={['fad', 'circle-exclamation']}
              className="red"
              width="75px"
              iconStyle={{
                '--fa-primary-color': 'white',
                '--fa-secondary-color': 'red',
                '--fa-secondary-opacity': 1.0,
              }}
            />
            <span className="text">Error accessing email and verification code information.</span>
          </>
        )}
        {!errorState && (
          <>
            {loading && (
              <ProgressMessage size={75} thickness={2} message="Verifying email, please wait..." />
            )}
            {!loading && (
              <>
                {success && (
                  <>
                    <Icon src="circle-check" className="blue" width="75px" />
                    <span className="text mt-5">Email verified successfully!</span>
                  </>
                )}
                {!success && (
                  <>
                    <Icon
                      src={['fad', 'circle-exclamation']}
                      className="red"
                      width="75px"
                      iconStyle={{
                        '--fa-primary-color': 'white',
                        '--fa-secondary-color': '#ff3b5e',
                        '--fa-secondary-opacity': 0.9,
                      }}
                    />
                    <span className="text mt-5">
                      Could not verify your email address! Maybe you've verified it already?
                    </span>
                  </>
                )}
                <DefaultButton
                  name={`Back to ${name}`}
                  style={{ width: '250px' }}
                  onClick={goToHome}
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmail;
